import DATATABLE_TRANSLATIONS from "./datatable_translations";

export default class ChildcaresDataTable {
  constructor() {
    $(document).ready(function() {
      showChildcaresTable();
    });

    $(document).on("turbo:render", function() {
      showChildcaresTable();
    });

    function showChildcaresTable() {
      $('#childcares-datatable').dataTable({
        "order": [],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#childcares-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "name"},
          {"data": "start_date"},
          {"data": "end_date"},
          {"data": "actions"}
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
